<template>
  <div
    id="foldaz"
    class="webview no-padding-top"
  >
    <notifications />
    <confirm-modal />

    <div class="main-content">
      <loading />
      <slot />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import Notifications from '@/components/app/Notifications'
import ConfirmModal from '@/components/app/ConfirmModal'
import Loading from '@/components/app/Loading'
import isBlank from 'is-blank'

export default {
  name: 'LayoutWebview',
  components: {
    Notifications,
    ConfirmModal,
    Loading
  },
  computed: {
    ...mapGetters([
      'isSignedIn'
    ]),
    ...mapState({
      currentUser: state => state.currentUser.currentUser
    }),
    isProfileValid () {
      return this.currentUser && !isBlank(this.currentUser.firstName + this.currentUser.lastName)
    }
  },
  watch: {
    isSignedIn (isSignedIn, wasSignedIn) {
      if (isSignedIn) {
        this.$router.push({ name: 'Home' })
      } else {
        this.$router.push({ name: 'SignInPage' })
      }
    }
  },
  methods: {
    ...mapActions({
      loadingStart: 'app/loadingStart'
    }),
    checkProfile () {
      if (this.isSignedIn && !this.isProfileValid) {
      }
    }
  },
  created () {
    this.$router.beforeEach((to, from, next) => {
      this.checkProfile()
      this.loadingStart()
      next()
    })
  }
}

</script>

<style lang="sass">
@import '~styles/imports'
@import '@fortawesome/fontawesome/styles.css'
@import '~styles/00-main'
@import '~styles/01-webview'

#foldaz
  display: flex
  flex-direction: column
  min-height: 100vh
  overflow: hidden
  padding-top: rem-calc(82);

  &.no-padding-top
    padding-top: 0

.main-content
   flex: 1

</style>



// WEBPACK FOOTER //
// src/layouts/LayoutWebview.vue